module.exports = __webpack_public_path__ + "static/img/test.c849bf44.png";